// Masjids pick theme colours freely, so a text colour can land on a background of
// (nearly) the same colour. These helpers pick the first candidate that stays readable.

function luminance(hex: string) {
  const value = parseInt(hex.slice(1, 7), 16);
  const [r, g, b] = [(value >> 16) & 255, (value >> 8) & 255, value & 255].map((channel) => {
    const c = channel / 255;
    return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

// WCAG contrast ratio, 1 (same colour) to 21 (black on white).
export function contrastRatio(a: string, b: string) {
  const [light, dark] = [luminance(a), luminance(b)].sort((x, y) => y - x);
  return (light + 0.05) / (dark + 0.05);
}

// The widgets draw their cards as the widget background mixed 85/15 with white.
export function mixWithWhite(hex: string, amount = 0.15) {
  const value = parseInt(hex.slice(1, 7), 16);
  return (
    "#" +
    [(value >> 16) & 255, (value >> 8) & 255, value & 255]
      .map((c) => Math.round(c * (1 - amount) + 255 * amount).toString(16).padStart(2, "0"))
      .join("")
  );
}

export function blackOrWhiteOn(background: string) {
  return contrastRatio("#ffffff", background) >= contrastRatio("#000000", background)
    ? "#ffffff"
    : "#000000";
}

// First candidate reaching minRatio against the background, else black or white.
export function readableColour(
  candidates: (string | undefined)[],
  background: string,
  minRatio = 3,
) {
  return (
    candidates.find(
      (colour) => colour && /^#[0-9a-f]{6}$/i.test(colour) && contrastRatio(colour, background) >= minRatio,
    ) || blackOrWhiteOn(background)
  );
}
